/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsMagnifyingGlassPlus: {
  name: 'magnifying-glass-plus';
  data: string;
} = {
  name: 'magnifying-glass-plus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 11a6 6 0 1 1 12 0 6 6 0 0 1-12 0Zm6-8a8 8 0 1 0 4.906 14.32l3.387 3.387a1 1 0 0 0 1.414-1.414l-3.387-3.387A8 8 0 0 0 11 3Zm0 5a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1H9a1 1 0 1 1 0-2h1V9a1 1 0 0 1 1-1Z" fill="currentColor"/></svg>`,
};
